/**
 * Strings for the email verification feature.
 *
 * Namespace: verifyEmail
 */
export const verifyEmail = {
  // Page
  page: {
    title: "E-mail cím megerősítése",
  },

  // Success
  success: {
    title: "E-mail cím megerősítve!",
    message: "Az e-mail címe sikeresen megerősítésre került. Most már bejelentkezhet a fiókjába.",
    goToLogin: "Tovább a bejelentkezéshez",
  },

  // Errors
  errors: {
    invalidToken: "Az e-mail megerősítő link érvénytelen vagy lejárt.",
    // A108 S7: shown instead of the "please wait" page subtitle once the confirmation is known to
    // have failed (no token, or the link check itself came back invalid).
    subtitle: "A megerősítés nem sikerült.",
  },

  // Processing state
  processing: {
    title: "E-mail cím megerősítése…",
    subtitle: "Kérjük, várjon egy pillanatot",
  },
} as const;
